import { takeLatest, put, all, call } from 'redux-saga/effects';
import { AxiosCall } from "../../../utils/axios";
import * as actions from './actions';

function* fetchFunFact() {
    try {
        const result = yield call(AxiosCall, '/dashboard/fun-facts/daily/');
        yield put(actions.fetchFunFactSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchFunFactFailure(e));
    }
}

export default function* funFactSaga() {
    yield all([
        // Watchers
        takeLatest(actions.FETCH_FUN_FACT.REQUEST, fetchFunFact),
    ])
}
